import moment from 'moment';
import React from 'react';
// Refer Your Colleagues
const SeventeenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>
          Dear {client_name ? client_name : `[Recipient's Name]`},
        </strong>
      </p>
      <p>
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        offers an exciting opportunity—if you refer a colleague to our event,
        both of you will receive a <strong>10% discount</strong> on the
        registration fee!
      </p>

      <p>
        Additionally, if you or your colleagues submit{' '}
        <strong>3 or more papers/abstracts</strong> together, you’ll be eligible
        for a <strong>group discount</strong>.
      </p>

      <p>
        To refer someone, simply share this registration link:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            {registration_link}
          </a>
        ) : (
          `[Insert registration link]`
        )}
        {' '}and ask them to mention your name during registration.
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default SeventeenStepWhatsappTemplate;
